// @flow
import styled from 'styled-components';

import BusinessLogo from 'components/payer/business-logo';

import { BACKGROUND_COLOR_PRIMARY } from 'styles/colors';
import { SPACING_MEDIUM } from 'styles/spacing';

export const Container = styled.div`
  min-height: 100vh;
  max-height: 100%;
`;

export const Logo = BusinessLogo.extend`
  padding: ${SPACING_MEDIUM} 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 80em;
  margin: 0 auto;
  background-color: ${BACKGROUND_COLOR_PRIMARY};
  padding-bottom: 12rem; /* footer height & spacing */
`;



// WEBPACK FOOTER //
// ./src/components/payer/credit-card-form/styles.js